import { openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ff7e2316"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "signature-field-container" };
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = {
    key: 1,
    class: "printed-name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!!_ctx.signatureBiometric)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "signature-image",
                src: _ctx.signatureBiometric,
                alt: _ctx.t('signature')
            }, null, 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.fullName), 1))
    ]));
}
